// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0213c5af","455":"bfb4cd2a","977":"a356f2e2"}[chunkId] + ".chunk.js";
};